import { z } from 'zod';

/** Telas que podem virar favorito do menu (Sessao 12). Mantida em sincronia com o menu do web (teste em navegacao.test.ts). */
export const ROTAS_FAVORITAVEIS = [
  '/precificar/formacao',
  '/precificar/lista',
  '/precificar/simulador',
  '/precificar/margens',
  '/vender/orcamentos',
  '/plano',
  '/plano/carteira',
  '/plano/compras',
  '/plano/necessidade',
  '/plano/custo-fabrica',
  '/plano/fluxo',
  '/clientes',
  '/custos/fichas-tecnicas',
  '/custos/centros',
  '/custos/atualizacoes',
  '/custos/criterios',
  '/custos/configuracoes-rateio',
  '/custos/cifs',
  '/custos/itens-cif',
  '/custos/rateios',
  '/custos/pessoal',
  '/cadastros/itens',
  '/cadastros/categorias',
  '/cadastros/unidades',
  '/cadastros/fornecedores',
  '/cadastros/imobilizados',
  '/cadastros/pessoas',
  '/cadastros/cargos',
  '/cadastros/tabelas',
  '/cadastros/condicoes',
  '/configuracoes/empresa',
  '/configuracoes/usuarios',
  '/configuracoes/perfis',
  '/configuracoes/reforma',
  '/configuracoes/plano',
  '/configuracoes/empresas',
  '/configuracoes/grupos',
] as const;
export type RotaFavoritavel = (typeof ROTAS_FAVORITAVEIS)[number];

export const MAX_FAVORITOS = 20;

export const favoritoSchema = z.object({ rota: z.enum(ROTAS_FAVORITAVEIS) });
export type FavoritoDto = z.infer<typeof favoritoSchema>;
export const removerFavoritoSchema = favoritoSchema;

/** Favoritos do usuario NESTA empresa, na ordem em que foram fixados. */
export interface FavoritosResponse {
  rotas: RotaFavoritavel[];
}
